<template>
<div v-if="loading">
    <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" />
</div>
<div v-else>
    <div class="sa-row sa-mb20 sa-d-f-a-center">
        <div class="sa-col-xs6 sa-col-sm2 sa-col-md2 sa-col-lg3">
            <h5>Telemedicine</h5>
        </div>
        <div class="sa-col-xs6 sa-col-sm10 sa-col-md10 sa-col-lg9 sa-d-f-end">
            <div class="sa-form-group sa-ml20" v-for="(item,index) in multisloData.duration" :key='index'>
                <input type="radio" :id="item" name="index" :value="item" v-model="duration" />
                <label :for="item">{{item}} Min</label>
            </div>
        </div>
    </div>
    <div class="sa-row" v-for="(item,index) in multisloData.schedules" :key="index">
        <template v-if="duration==item.base_duration">
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6" v-for="(item,index) in item.duration" :key="index">
                <div class="sa-card sa-card-gray sa-card-noshadow sa-custom-disabled">
                    <div class="sa-row sa-mb20">
                        <div class="sa-col-xs4 sa-col-sm4 sa-col-md4 sa-col-lg4">
                            <label>Duration (Min)</label>
                            <input type="text" class="sa-form-control sa-disabled sa-card-noshadow" v-model='item.dur' placeholder="500" disabled>
                        </div>
                        <div class="sa-col-xs4 sa-col-sm4 sa-col-md4 sa-col-lg4">
                            <label>Base Price</label>
                            <input type="text" class="sa-form-control sa-card-noshadow" v-model='item.basic_fee.fee' placeholder="600" :class="item.is_custom==false ? 'sa-highlight' : ''">
                        </div>
                        <div class="sa-col-xs4 sa-col-sm4 sa-col-md4 sa-col-lg4">
                            <label>Custom Price</label>
                            <input type="text" v-model='item.custom_fee.fee' class="sa-form-control sa-disabled sa-card-noshadow" placeholder="600" disabled :class="item.is_custom==true ? 'sa-highlight' : ''">
                        </div>
                    </div>
                    <div class="sa-row sa-d-f-sbetween" v-if="item.is_toggle">
                        <div class="sa-col-xs6 sa-col-sm8 sa-col-md8 sa-col-lg8">
                            <span v-if="item.active==false">Enable Duration</span>
                            <span v-if="item.active !=false">Disable Duration</span>
                        </div>
                        <div class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4 sa-switch sa-ciyan-blue sa-text-right">
                            <input type="checkbox" :id="item.id" v-model="item.active" />
                            <label :for="item.id">
                                <span class="sa-input-box"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
    <div class="sa-text-right">
        <button @click='saveMultiSchedule()' class="sa-btn sa-btn-primary sa-btn-large">save</button>
    </div>
</div>
</template>

<script>
import { duration } from "moment";
import {
    pro_url
} from "../../../config/endpoints";
export default ({
    data() {
        return {
            multisloData: '',
            loading: false,
            duration:'',
        }
    },
    methods: {
        getMulti() {
            let _self = this;
            _self.loading = true;
            _self.$store
                .dispatch("httpGet", {
                    uri: `${pro_url}/getServiceTypeConfigForMultiSlot`,
                    body: {}
                })
                .then(response => {
                    if (response.status === 1000) {
                        this.multisloData = response.data;
                        this.duration = response.data.duration[0]
                    }
                    _self.loading = false;
                })
                .catch(e => {
                    // console.log(e);
                });

        },
        saveMultiSchedule() {
            let _self = this;
            _self.loading = true;
            _self.$store
                .dispatch("httpPost", {
                    uri: `${pro_url}/addServiceTypeConfigForMultiSlot`,
                    body: {
                        "schedules": this.multisloData.schedules
                    }
                })
                .then(response => {
                    _self.loading = false;
                    if (response && response.status === 1000) {
                        _self.$store.dispatch('SET_ALERTMESSAGE', {
                            msg: response.message,
                            class: 'sa-a-success'
                        })
                    } else if (response && response.status == "2001") {
                        _self.$store.dispatch("SET_ALERTMESSAGE", {
                            msg: "Session Expired. Please login again",
                            class: "sa-a-danger",
                        });
                        _self.$localStorage.remove("token");
                        _self.$localStorage.remove("userdata");
                        _self.$router.push({
                            path: "/"
                        });
                    } else {
                        _self.$store.dispatch('SET_ALERTMESSAGE', {
                            msg: response.message,
                            class: 'sa-a-danger'
                        })

                    }
                })
                .catch(e => {
                    // console.log(e);
                });

        }
    },
    created() {
        let _self = this;
        _self.getMulti();
        _self.userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
    }
})
</script>
